<quill-editor 
    bounds="self"
    [formControl]="form().get(id())"
    (onEditorChanged)="onEditorChanged.emit($event)"
    (onContentChanged)="onContentChanged.emit($event)"
    [ngClass]="bgClass()"
    [modules]="modules()"
    [readOnly]="readOnly()" 
    [placeholder]="placeholder()">
</quill-editor>